import React, { useState, useEffect } from 'react';
import { Container, Typography, Box, Button, TextField, CircularProgress, Alert, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import api from '../../axios';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ContextNavBar from '../../components/ContextNavBar';
import ModuleHeader from '../../components/ModuleHeader';

const LIME = '#00F1A7'; const DARK = '#1C1C1E';

function InstrutoresLista() {
  const navigate = useNavigate();
  const [lista, setLista] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');
  const [dialog, setDialog] = useState({ open: false, edit: null, nome: '', email: '', telefone: '', especialidade: '' });
  const [saving, setSaving] = useState(false);

  const carregar = async () => {
    setLoading(true); setErro('');
    try { const r = await api.get('/instrutores/'); setLista(r.data || []); }
    catch (e) { setErro(e.response?.data?.detail || 'Erro'); }
    setLoading(false);
  };
  useEffect(() => { carregar(); }, []);

  const abrirNovo = () => setDialog({ open: true, edit: null, nome: '', email: '', telefone: '', especialidade: '' });
  const abrirEditar = (i) => setDialog({ open: true, edit: i, nome: i.nome, email: i.email || '', telefone: i.telefone || '', especialidade: i.especialidade || '' });

  const salvar = async () => {
    if (!dialog.nome.trim()) { setErro('Nome é obrigatório'); return; }
    setSaving(true); setErro('');
    try {
      if (dialog.edit) await api.put(`/instrutores/${dialog.edit.id}`, { nome: dialog.nome, email: dialog.email, telefone: dialog.telefone, especialidade: dialog.especialidade });
      else await api.post('/instrutores/', { nome: dialog.nome, email: dialog.email, telefone: dialog.telefone, especialidade: dialog.especialidade });
      setDialog({ ...dialog, open: false });
      carregar();
    } catch (e) { setErro(e.response?.data?.detail || 'Erro ao salvar'); }
    setSaving(false);
  };

  const deletar = async (id) => {
    if (!window.confirm('Deletar instrutor?')) return;
    try { await api.delete(`/instrutores/${id}`); carregar(); }
    catch (e) { alert(e.response?.data?.detail || 'Erro'); }
  };

  if (loading) return <><Header /><ContextNavBar context="cursos" /><Container sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, md: 2 }, textAlign: 'center' }}><CircularProgress /></Container><Footer /></>;

  return (
    <>
      <Header />
      <ContextNavBar context="cursos" />
      <Container maxWidth="lg" sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, md: 2 } }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3, flexDirection: { xs: 'column', md: 'row' }, gap: { xs: 1, md: 0 } }}>
          <Typography variant="h4" sx={{ fontWeight: 800, fontSize: { xs: '1.2rem', md: '1.5rem' } }}>Instrutores</Typography>
          <Button variant="contained" startIcon={<AddIcon />} onClick={abrirNovo} sx={{ bgcolor: LIME, color: DARK }}>Novo Instrutor</Button>
        </Box>
        {erro && <Alert severity="error" sx={{ mb: 2 }}>{erro}</Alert>}
        <TableContainer component={Paper} elevation={2} sx={{ borderRadius: 2, overflowX: 'auto' }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow><TableCell sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>Nome</TableCell><TableCell sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>Email</TableCell><TableCell sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>Telefone</TableCell><TableCell sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>Especialidade</TableCell><TableCell sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>Ações</TableCell></TableRow>
            </TableHead>
            <TableBody>
              {lista.map(i => (
                <TableRow key={i.id} hover>
                  <TableCell>{i.nome}</TableCell>
                  <TableCell>{i.email || '—'}</TableCell>
                  <TableCell>{i.telefone || '—'}</TableCell>
                  <TableCell>{i.especialidade || '—'}</TableCell>
                  <TableCell>
                    <IconButton size="small" onClick={() => abrirEditar(i)}><EditIcon fontSize="small" /></IconButton>
                    <IconButton size="small" onClick={() => deletar(i.id)}><DeleteIcon fontSize="small" /></IconButton>
                  </TableCell>
                </TableRow>
              ))}
              {lista.length === 0 && (
                <TableRow><TableCell colSpan={5} align="center"><Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>Nenhum instrutor cadastrado.</Typography></TableCell></TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Dialog open={dialog.open} onClose={() => setDialog({ ...dialog, open: false })} maxWidth="sm" fullWidth>
          <DialogTitle>{dialog.edit ? 'Editar Instrutor' : 'Novo Instrutor'}</DialogTitle>
          <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 2 }}>
            <TextField label="Nome" value={dialog.nome} onChange={e => setDialog({ ...dialog, nome: e.target.value })} fullWidth required />
            <TextField label="Email" value={dialog.email} onChange={e => setDialog({ ...dialog, email: e.target.value })} fullWidth />
            <TextField label="Telefone" value={dialog.telefone} onChange={e => setDialog({ ...dialog, telefone: e.target.value })} fullWidth />
            <TextField label="Especialidade" value={dialog.especialidade} onChange={e => setDialog({ ...dialog, especialidade: e.target.value })} fullWidth />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDialog({ ...dialog, open: false })}>Cancelar</Button>
            <Button variant="contained" onClick={salvar} disabled={saving} sx={{ bgcolor: LIME, color: DARK }}>{saving ? 'Salvando...' : 'Salvar'}</Button>
          </DialogActions>
        </Dialog>
      </Container>
      <Footer />
    </>
  );
}

export default InstrutoresLista;
